import { useState, useCallback } from 'react'
import { ModalProps } from '../../types/modal'
import Modal from '../shared/Modal'
import Checkbox from '@components/forms/Checkbox'
import Button from '@components/shared/Button'
import useTrafficSettings, {
  useVenueFilter,
  VenueFilter,
} from '@components/trade/useSettings'
import { useTranslation } from 'next-i18next'

const VenueFilterFormModal = ({ isOpen, onClose }: ModalProps) => {
  const { t } = useTranslation('trade')
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="mb-4 text-center">{t('filter.title.venue')}</h2>
      <VenueFilterForm onSave={onClose} />
    </Modal>
  )
}

export default VenueFilterFormModal

export const VenueFilterForm = ({ onSave }: { onSave: () => void }) => {
  const { t } = useTranslation('trade')
  const { defaultVenueFilter, settings } = useTrafficSettings()
  const [savedForm, setSavedForm] = useVenueFilter()
  const [form, setForm] = useState(savedForm)

  const handleFormChange = useCallback((venue: string) => {
    setForm((prevState: VenueFilter) => ({
      ...prevState,
      [venue]: !prevState[venue],
    }))
  }, [])

  const handleApplyFilter = () => {
    setSavedForm(form)
    onSave()
  }

  const isValid = Object.values(form).some((value) => value)

  return (
    <>
      <div className="mb-6 space-y-3">
        {Object.keys(defaultVenueFilter).map((venueId) => (
          <Checkbox
            key={venueId}
            checked={form[venueId]}
            onChange={() => handleFormChange(venueId)}
          >
            <span className="text-sm">
              {
                settings?.available_venues.find((v) => v.id === venueId)
                  ?.display_name
              }
            </span>
          </Checkbox>
        ))}
      </div>
      <div className="flex justify-end">
        <Button onClick={() => handleApplyFilter()} disabled={!isValid}>
          {t('filter.venue.apply')}
        </Button>
      </div>
    </>
  )
}
